module.exports = __webpack_public_path__ + "media/rg.06a2485d.mp4";